import { useCallback, useEffect, useState } from 'react';

import useDelayFn from '~hooks/useDelayFn';
import { type AssetId } from '~modules/media-library/model/Asset';
import { CanvaModal } from '~modules/media-library/view/CanvaModal/CanvaModal';

type CanvaModalControllerProps = {
  assetId: AssetId;
  onClose: () => void;
};

export function CanvaModalController({ assetId, onClose }: CanvaModalControllerProps) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setIsOpen(Boolean(assetId));
  }, [assetId]);

  // Handler: close dialog, but delay the closing to have smoother transitions
  const delayedOnClose = useDelayFn(onClose, 500);
  const handleOnClose = useCallback(() => {
    delayedOnClose();
  }, [delayedOnClose]);

  return <CanvaModal isOpen={isOpen} assetId={assetId} onClose={handleOnClose} />;
}
